import { useState, useEffect } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetFsiTrackingActionReportQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { FsiTrackingResponse } from "../../../services/ActionReports/ActionReportAPI.types";

export const defaultFsiActionReportData = (): FsiTrackingResponse => ({
  inFsiCount: 0,
  outFsiCount: 0,
  inFsi: [],
  outFsi: [],
});

export const FetchFsiActionReportData = (period: string, skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: apiData,
    isFetching,
    isError,
    refetch,
  } = useGetFsiTrackingActionReportQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
    },
    { skip: skipRequest },
  );

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [fsiData, setFsiData] = useState<FsiTrackingResponse>(defaultFsiActionReportData());

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);

    if (!isFetching && !isError && apiData) {
      setFsiData(apiData);
    }
  }, [isFetching, period, isError, apiData]);

  return { isLoading, fsiData, errorStatus, refetch };
};
